import ButtonSpinner from "@components/ButtonSpinner"
import { Button as HeadlessUiButton } from "@headlessui/react"

interface Props {
  className?: string
  disabled?: boolean
  onClick?: () => void
  submitting?: boolean
  title: string
  type?: "button" | "submit" | "reset"
  // NOTE: Like the app's Button: `primary` is the one main call to action,
  // `secondary` the quieter filled button for the less important action.
  variant?: "primary" | "secondary"
}

export default function Button({
  className = "",
  disabled = false,
  onClick,
  submitting = false,
  title,
  type = "button",
  variant = "primary",
}: Props) {
  return (
    <HeadlessUiButton
      aria-busy={submitting || undefined}
      className={`${className} ${variant === "primary" ? "vm-button-primary" : "vm-button-secondary"}`}
      disabled={disabled || submitting}
      onClick={onClick}
      // NOTE: The Maestro flows find the button by its title.
      title={title}
      type={type}
    >
      {submitting && (
        <ButtonSpinner
          className={variant === "secondary" ? "!text-vm-ink" : ""}
        />
      )}

      {/* NOTE: In its own element, so inserting the spinner next to it works
      when page translation has replaced the text node (translationDomGuard). */}
      <span>{title}</span>
    </HeadlessUiButton>
  )
}
